import type { ImageLoaderProps } from 'next/image';
import config from '@packages/config';

// https://nextjs.org/docs/api-reference/next.config.js/custom-image-loader-config#akamai
// https://techdocs.akamai.com/ivm/reference/test-images-on-demand
// implementation changed, based on https://empiriecom.atlassian.net/browse/INFORM-2655
export function akamaiLoader({ src, width }: ImageLoaderProps) {
  if (!src.includes(`//bilder.${config.host.domain}`) || !width || src.includes('w=')) return src;

  if (src.includes('?')) return `${src}&w=${width}`;

  return `${src}?w=${width}`;
}
